import React from 'react';
import { Icon } from '@iconify-icon/react';

export default function Documentation() {
    return (
        <main className="flex flex-col items-center justify-center w-full h-full bg-neutral-50 text-neutral-600 text-xl">
            <h1 className="text-4xl font-semibold">Documentation</h1>
            <p className="mt-4">{_t.global.underCostructionPage()}</p>
            <Icon icon="svg-spinners:blocks-shuffle-3" width="2.5rem" height="2.5rem" className="p-6" />
        </main>
    );
}
